<template>
  <div>


    <a-form class="row">
       <a-form-item class="col-md-4">
            <h5>Filtro por Categoría:</h5>
                <a-select
                    placeholder="Seleccione Categoria"
                    :value="selectedCategory"
                    @change="selectCategory"
                    style="width: 100%"
                >
                    <a-select-option v-for="item in  categories" :key="item.key" :value="item.value">
                    {{item.title}}
                    </a-select-option>
                </a-select>
        </a-form-item>
        <a-form-item class="col-md-4">
            <h5>Filtro por Posición:</h5>
                <a-select
                    placeholder="Seleccione Posición"
                    :value="selectedPosition"
                    @change="selectPosition"
                    style="width: 100%"
                >
                    <a-select-option v-for="item in  positions" :key="item.name" :value="item.name">
                    {{item.description}}
                    </a-select-option>
                </a-select>
        </a-form-item>
        <a-form-item class="col-md-4">
            <br>
              <a-button type="primary" class="float-right" @click="showDrawer({})">+ Crear {{positions[0].description}} </a-button>
        </a-form-item>
    </a-form>

    <table class="ant-table-fixed" style="width: 100%;">
      
      <thead class="ant-table-thead">
        <tr class="ant-table-row">
          <th>
          </th>
          <th v-for="item in columns" :key="item.key">
            <span class="ant-table-header-column">
              <span class="ant-table-column-title">{{item.title}}</span>
            </span>
          </th>
        </tr>
      </thead>
      <draggable v-model="rows" tag="tbody" class="ant-table-tbody" @change="handleChange">
        <tr v-for="item in rows" :key="item.id" class="ant-table-row">

          <td class="ant-table-selection-column">
            <label class="ant-radio-wrapper"  @click="showDrawer(item)">
              <span class="ant-radio" :class="item == banner ? 'ant-radio-checked': ''">
                <input type="radio" class="ant-radio-input" value="true">
                <span class="ant-radio-inner">
                </span>
              </span>
            </label>
          </td>

          <td>
            <a-switch :checked="item.isVisible" disabled @change='onChange' />
          </td>

          <td>
            <a href="javascript:void(0)" @click="showModalPrevisualize(item)"><img :src="item.urlBanner" class="rounded-pill" style="max-height: 30px" alt=""></a>
          </td>

          <td>
            <a :href="item.redirectUrl" target="_blank"> <a-icon type="link" /> URL</a>
          </td>

          <td>
            {{item.campaignName}}
          </td>

          <td>
            {{
              item.position == 'MAIN_BANNER' ? 'Banner Principal' : 
                item.position == 'MAIN_BANNER_ABOVE' ? 'Banner Principal Arriba' :
                item.position == 'ADVERTISING' ? 'Publicidad' :
                item.position == 'ADVERTISING_MENU' ? 'Imagenes de Menu' :
                item.position == 'NEW_SERVICES' ? 'Nuevos Servicios' :
                item.position == 'STATIC_BANNER' ? 'Banner Estático' :
                item.position == 'MAIN_BANNER_BELOW' ? 'Banner Principal Abajo' : ''
            }}
          </td>

          <td>
            <a-tooltip placement="top" :title="item.dateTimeFinished | moment('llll')">
              <a-tag >{{item.dateTimeFinished | moment('from')}}</a-tag>
            </a-tooltip>
          </td>

          <td >
            <span>{{item.city || 'Todas las ciudades' }}</span>
          </td>
                  
        </tr>
      </draggable>
    </table>


<!-- <a-table :columns="columns" :dataSource="rows" :rowSelection="{onChange:onSelect, type:'radio'}" :pagination="{ pageSize: 30 }">
      
      <span slot="status" valu slot-scope="text, record">
        {{record.dateTimeFinished  | moment('isBefore') }} 
        <a-switch :checked="record.isVisible" disabled @change='onChange' />

      </span>

      <span slot="url" slot-scope="url">
          <a :href="url" target="_blank"> <a-icon type="link" /> URL</a>
      </span>

      <span slot="image" slot-scope="text, record" class="text-center">
          <a href="javascript:void(0)" @click="showModalPrevisualize(record)"><img :src="text" class="rounded-pill" style="max-height: 30px" alt=""></a>
      </span>

      <span slot="action" slot-scope="banner">
        <a-button type="primary" size="small" icon="form" @click="showDrawer(banner)"> </a-button>
      </span>

      <span slot="dateFinished" slot-scope="dateFinished">
        <a-tooltip placement="top" :title="dateFinished | moment('llll')">
          <a-tag >{{dateFinished | moment('from')}}</a-tag>
        </a-tooltip>
      </span>

      <span slot="city" slot-scope="city" >
        <span>{{city || 'Todas las ciudades' }}</span>
      </span>

    </a-table> -->
    

    <a-drawer
      :title="titleDetailBanner"
      placement="right"
      :closable="false"
      @close="onClose"
      :visible="bannerDetailShow"
      width="780"
      wrapClassName="drawer_ftd"
      v-on:closeDraw="close()">

      <detail-banner :banner.sync="banner"  :positions="positions" v-on:closeDetail="updateBannerDetailShow($event)" v-on:updateFetchBanner="fetchBanners()" />

    </a-drawer>

      <a-modal title="Previsualización de banner" v-model="visibleModalPrevisualize" @ok="hideModalPrevisualize" >
        <div style="padding:10px; text-align:center">
          <img :src="banner.urlBanner" style="width:90%" alt="">
        </div>

        <a-row>
          <a-col :span="24" class="header">
              <img src="resources/images/layouts-web/header.jpg"/>
          </a-col>
        </a-row>
       <a-row>
          <a-col :span="24" class="main_banner">
            <img v-if="banner.position == 'MAIN_BANNER'" :src="banner.urlBanner" alt="">
          </a-col>
       </a-row>
       <a-row>
          <a-col :span="24" class="shortcut">
           <img src="resources/images/layouts-web/shortcut.jpg" style="width:100%"/>
          </a-col>
       </a-row>
       <a-row>
          <a-col :span="24" class="offers">
           <img src="resources/images/layouts-web/offers.jpg" style="width:100%"/>
          </a-col>
       </a-row>

        <a-row>
          <a-col :span="12" class="advertising_left">
           <img v-if="banner.position == 'ADVERTISING_LEFT'" :src="banner.urlBanner" style="width:100%" alt="">
          </a-col>
          <a-col :span="12" class="advertising_right">
           <img v-if="banner.position == 'ADVERTISING_RIGHT'" :src="banner.urlBanner" style="width:100%" alt="">
          </a-col>
       </a-row>

    </a-modal>

  </div>
</template>
<script>

import { Modal } from 'ant-design-vue'

import DetailBanner from './widgets/detailBanner'
import CountDown from './widgets/countDown'

import { RepositoryFactory } from '@/repository/RepositoryFactory'
import draggable from 'vuedraggable'

const BannersRepository = RepositoryFactory.get('banners')
const CategoriesRepository = RepositoryFactory.get('categories')

const columns = [
  {
    dataIndex: 'status',
    key: 'status',
    slots: { title: 'customTitle' },
    scopedSlots: { customRender: 'status' },
  }, {
    title: 'Imagen',
    dataIndex: 'urlBanner',
    key: 'urlBanner',
    align: 'center',
    scopedSlots: { customRender: 'image' },
  }, 
  {
    title: 'Enlace',
    dataIndex: 'redirectUrl',
    key: 'redirectUrl',
    align: 'center',
    scopedSlots: { customRender: 'url' },
  }, 
  {
    title: 'Campaña',
    key: 'campaignName',
    dataIndex: 'campaignName',
  }, 
  {
    title: 'Posción',
    key: 'position',
    dataIndex: 'position',
  }, 
  {
    title: 'Fecha de Finalización',
    key: 'dateTimeFinished',
    dataIndex: 'dateTimeFinished',
    align: 'center',
    scopedSlots: { customRender: 'dateFinished' },
  },
  {
    title: 'Ciudad',
    key: 'city',
    dataIndex: 'city',
    align: 'center',
    scopedSlots: { customRender: 'city' },
  },
  //  {
  //   title: 'Categorias',
  //   key: 'listCategories',
  //   dataIndex: 'listCategories',
  //   align: 'center',
  //   scopedSlots: { customRender: 'categories' },
  // },

]

export default {
  name: 'Banners',
  components: {
    DetailBanner,
    CountDown,
    Modal,
    draggable
  },

  data() {
    return {
      selectedCategory: 0,
      selectedPosition: 'MAIN_BANNER',
      columns,
      visibleModalPrevisualize: false,
      rows: [],
      selectedRowKeys: [],
      bannerDetailShow: false,
      slider: {},
      dataCategories: [],
      banner: {},
      categories: [],
      // position:'OK'

    }
  },
  props: ['positions'],
  created() {
    this.fetchBanners(0)
  },
  mounted(){
    this.fetchCategories()
  },
  computed: {
    titleDetailBanner: function() {
      return this.banner.idBanner ? ('Configuración de Banner: ' + this.banner.campaignName) : 'Nuevo Banner'
    },
    // position2: function (){
    //   return this.position
    // }
    // rows: function() {
    //   return this.data.map((item, index) => {
    //     return item

    //   })
    // },
  },
  methods: {

    selectCategory(category){
      this.selectedCategory = category
      this.fetchBanners(this.selectedCategory, this.selectedPosition)
      // console.log("selectCategory", selected)
    },
    selectPosition(pos){
      this.selectedPosition = pos
      this.fetchBanners(this.selectedCategory, this.selectedPosition)
    },

    showModalPrevisualize(banner) {
      // console.log("OK". banner)
      this.banner = banner
      this.visibleModalPrevisualize = true
    },
    hideModalPrevisualize() {
      this.visibleModalPrevisualize = false
    },
    async handleChange() {
      this.rows.forEach((banner, index) => {
          banner.order = index + 1;
        });
      let {data} = await BannersRepository.updateOrder(this.rows.map(b => { return +b.idBanner }));
    },
    updateBannerDetailShow(status) {
      this.bannerDetailShow = status
      console.log(status)
    },
    async fetchBanners(categoryId, position) {
      console.log('Está haciendo el fetch')
      console.log(position)
      try {
        const { data } = await BannersRepository.get(position, categoryId)

        this.rows = data.data.map((item) => {
          item['isVisible'] = this.$moment(item.dateTimeFinished).isAfter()
          return item
        })
      } catch (error) {
        this.$notification['warning']({
          message: error.code,
          description: error.message,
        })
      }
    },
    callback (key) {
      console.log(key)
    },
    async fetchCategories() {
      try {
        const { data } = await CategoriesRepository.get()

        console.log(data)
        const homeCategory = {
          id: 0,
          name: 'Home (Página de Inicio)',
          url: 'http://lh3.googleusercontent.com/nB3jhpuGy3Tmw9FHXmE8PvkheE9PowhhPAnhejuT0ZfKnAOp08UlKwnCzH4nKcjM2KaFWJgPEFyTJo600tvZ-6aEmD1rJ_YuWOA',
          primaryColor: '#84D24C',
          children: [],
        }
        console.log(homeCategory)

        data.departmentList.unshift(homeCategory)

       
         this.categories = data.departmentList.map((item, index) => {
          return {
            title: item.name,
            value: item.id,
            key: item.id,
            children: [],
          }
        })

        console.log(this.categories)

        // this.categories.unshift({homeCategory})
      } catch (error) {
        this.$notification['warning']({
          message: error.code,
          description: error.message,
        })
      }
    },

    onChange(checked) {
      console.log(`a-switch to ${checked}`)
    },
    showDrawer(banner) {
      console.log(banner)
      this.banner = banner
      this.bannerDetailShow = true
    },
    onClose() {
      this.bannerDetailShow = false
    },
    onSelect2() {
      console.log('ok')
    },
    onSelect(record, selected) {
      // this.selectedRowKeys = selected

      console.log(this.rows[record[0]])
      console.log(record, selected)
      this.showDrawer(selected[0])
    },

  },
}
</script>

<style lang="scss">

@media only screen and (max-width: 768px) {
  /* For mobile phones: */
  .drawer_ftd .ant-drawer-content-wrapper{
    width:92%!important;
    padding-right: 145px;
    height: 100vh;
  }

  .ant-upload.ant-upload-drag{
    padding-bottom: 5px;
    height: auto;
  }
}

  .ant-table-thead > tr > th, .ant-table-tbody > tr > td {
    padding: 10px 7px;
    font-size: 12px;
  }

  .ant-table-tbody > tr > td{
    cursor: pointer;
    color: rgba(0, 0, 0, 0.65);
  }

.ant-modal{

  width: 520px!important;

  .ant-modal-body{
    padding: 0px;
    background-color: #f4f4f4;
    max-height: 60vh;
    overflow-y: auto;
  }

  .header{

//    height: 50px;
    width: 100%;
    display: block;
    background-color: #418fde;
    padding: 0px;
    img{
      width: 100%
    }

  }

  .main_banner{
    min-height: 100px;
    width: 100%;
    background-color: #e2e2e2;
    display: block;
    img{
      width: 100%
    }
  }

  .shortcut{
    img{
      width: 100%;
    }
  }

  .advertising_left,
  .advertising_right{
    min-height: 100px;
    display: block;
  }

}

</style>
